export default __webpack_public_path__ + "static/media/couple.740c4217.png";